/**
 * Normalize the object to send to the dashboard filters flow (clicking the visual and filtering functionality).
 * @param {Array} filters - the array of chips to show on the screen.
 * @param {Array} engagements - the array of engagements - just numbers.
 * @param {function} onClearFilter - functions to clear the results.
 * @returns {object} normalize dashboard filters object.
 * */
export default (filters, engagements, onClearFilter) => {
	return {
		filters,
		engagements,
		onClearFilter
	};
};
